export default "__VITE_ASSET__DgHFz1IK__"